/**
 * KAN-341: раздел "Биллинг": всё про деньги кабинета в одном месте, только владельцу.
 * KAN-1000: тарифов нет. Раздел называется "Баланс и расход": остаток кошелька,
 * пополнение, журнал списаний за расход и история платежей. Абонентской платы,
 * витрины тарифов и отмены подписки больше нет.
 */
import { useEffect, useState } from 'react';
import { PiggyBank } from 'lucide-react';
import { PageLayout } from '@/components/layout';
import { PaymentHistory } from '@/components/billing/PaymentHistory';
import { LegalFooter } from '@/components/legal/LegalFooter';
import { TopupDialog } from '@/components/wallet/TopupDialog';
import { WalletBalanceCard } from '@/components/wallet/WalletBalanceCard';
import { WalletEntriesSection } from '@/components/wallet/WalletEntriesSection';
import { useWallet } from '@/hooks/useWallet';
import { BILLING_TITLE } from '@/lib/wallet';

export function BillingPage(): JSX.Element {
  const [topupOpen, setTopupOpen] = useState(false);
  const { data: wallet } = useWallet();

  useEffect(() => {
    document.title = `${BILLING_TITLE} - SMETA AI`;
  }, []);

  return (
    <PageLayout
      data-testid="billing-page"
      title={BILLING_TITLE}
      subtitle={<span className="hidden sm:inline">Кошелёк кабинета в рублях: пополнение и списания</span>}
      titleIcon={
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-blue-600">
          <PiggyBank className="h-5 w-5 text-white" />
        </div>
      }
      breadcrumbs={[{ label: 'Главная', href: '/' }, { label: BILLING_TITLE }]}
    >
      <div className="space-y-6">
        <WalletBalanceCard onTopup={() => setTopupOpen(true)} />
        <WalletEntriesSection />
        <PaymentHistory />
      </div>
      {/* KAN-1003: соглашение, политика, цены, реквизиты и поддержка */}
      <LegalFooter className="mt-8" />
      {wallet && (
        <TopupDialog
          open={topupOpen}
          onOpenChange={setTopupOpen}
          minAmount={wallet.min_topup}
          maxAmount={wallet.max_topup}
        />
      )}
    </PageLayout>
  );
}

export default BillingPage;
